import { Navigate, Outlet, useLocation } from "react-router-dom";
import Auth from '../../component/Auth';

function loggedIn() {
    return new Auth().isUserAuthenticated();
}

function RequireAuth() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    if (params.get("ex")) {
        new Auth().authenticateUser(true, 1, 1);
        return <Navigate to={location.pathname} replace />;
    }

    if (!loggedIn()) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}

export default RequireAuth;
